'use es6';

import http from 'hub-http/clients/apiClient';
import { HUBSPOT_FOLDER_PATH } from 'DesignData/constants/Folders';
const BASE_URI = 'designmanager/v1/default-asset/by-path';
export function fetchDefaultModules() {
  return http.get(`${BASE_URI}/${HUBSPOT_FOLDER_PATH}`, {
    timeout: 60000,
    query: {
      sidebar: true
    } // For BE usage tracking

  });
}